var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgRemoveEdit = function SvgRemoveEdit(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 6a6 6 0 1 1 12 0A6 6 0 1 1 0 6Z",
    fill: "#CCC"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.972 6c0-.221.18-.4.4-.4h5.256a.4.4 0 1 1 0 .8H3.372a.4.4 0 0 1-.4-.4Z",
    fill: "#fff"
  })));
};
export default SvgRemoveEdit;